<template>
  <div id="app">
    <PageHeader/>
    <Thanks @toggleSigns="toggleSigns"/>
    <Start id="start-view" :signsOpen="signsOpen"/>
    <ScrollDown :bottom="atBottom"/>
    <a id="one-page-down" class="one-page-down"></a>
    <SceneOne :scrollPos="scrollPosition"/>
    <SceneTwo :scrollPos="scrollPosition"/>
    <SceneThree :scrollPos="scrollPosition"/>
    <SceneFour :scrollPos="scrollPosition"/>
    <TextFloat class="why" :stringh="strings.why.p"/>
    <TextFloat
      v-for="(fact, index) in strings.facts"
      :key="index"
      :stringh="fact"
      class="scale-trans not-full"
      :class="'why-' + index"
      v-scroll-reveal
    />
    <PopFloat id="qa" :accordian="strings.accordian"/>
    <SceneFive :scrollPos="scrollPosition"/>
    <TextFloat id="press" :stringh="strings.press.text"/>
  </div>
</template>

<script>
import Start from './components/Start.vue'
import PageHeader from './components/PageHeader.vue'
import TextFloat from './components/TextFloat.vue'
import PopFloat from './components/PopFloat.vue'
import ScrollDown from './components/ScrollDown.vue'
import Thanks from './components/Thanks.vue'

import SceneOne from './components/SceneOne.vue'
import SceneTwo from './components/SceneTwo.vue'
import SceneThree from './components/SceneThree.vue'
import SceneFour from './components/SceneFour.vue'
import SceneFive from './components/SceneFive.vue'

import strings from '@/data/strings.json'

export default {
  name: 'app',
  data () {
    return {
      scrollPosition: 0,
      page: 0,
      strings: strings,
      atBottom: false,
      frame: [
      ],
      signsOpen: false
    }
  },
  components: {
    Start,
    PageHeader,
    TextFloat,
    PopFloat,
    ScrollDown,
    SceneOne,
    SceneTwo,
    SceneThree,
    SceneFour,
    SceneFive,
    Thanks
  },
  methods: {
    toggleSigns () {
      this.signsOpen = !this.signsOpen
    },
    getScrollPosition () {
      let doc = document.documentElement
      return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
    },
    atPage () {
      const windowHeight = window.innerHeight
      return Math.floor(this.getScrollPosition() / windowHeight)
    },
    pageTriggerPosition () {

    },
    distanceToTop (el) {
      return el.getBoundingClientRect().top
    },
    getDocHeight () {
      let body = document.body
      let html = document.documentElement
      return Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
      )
    },
    doUpdate () {
      this.scrollPosition = this.getScrollPosition()
      this.page = this.atPage()
      const onePageDown = document.getElementById('one-page-down')
      onePageDown.style.top = this.scrollPosition + (window.innerHeight * 1) + 'px'
      if (this.getDocHeight() < this.scrollPosition + window.innerHeight * 1.5) {
        this.atBottom = true
      } else {
        this.atBottom = false
      }
      window.requestAnimationFrame(this.doUpdate)
    }
  },
  mounted () {
    window.requestAnimationFrame(this.doUpdate)
    /*
    document.addEventListener('scroll', (e) => {
      this.scrollPosition = this.getScrollPosition()
      this.page = this.atPage()
      const onePageDown = document.getElementById('one-page-down')
      onePageDown.style.top = this.scrollPosition + (window.innerHeight * 1) + 'px'
      if (this.getDocHeight() < this.scrollPosition + window.innerHeight * 1.5) {
        this.atBottom = true
      } else {
        this.atBottom = false
      }
    }) */
  }
}
</script>

<style lang="scss">
html,
body {
  scroll-behavior: smooth;
  background-color: #ff5555;
  color: #ffff76;
  font-family: sofia-pro, sans-serif;
  font-size: 1rem;
  line-height: 1.15rem;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}
* {
  box-sizing: border-box;
}
h2 {
  font-size: 4.3rem;
  line-height: 4.5rem;
  padding: 0px 23px;
  margin-top: 0;
  @media only screen and (max-width: 1930px) {
    font-size: 4rem;
    line-height: 4.2rem;
    padding: 0px 30px;
  }
  @media only screen and (max-width: 1400px) {
    font-size: 3.2rem;
    line-height: 3.5rem;
    padding: 0px 20px;
  }
  @media only screen and (max-width: 600px) {
    font-size: 2.3rem;
    line-height: 2.5rem;
    padding: 0px 3px;
  }
}
h3 {
  font-size: 6.3rem;
  line-height: 6.5rem;
  padding: 0px 23px;
  @media only screen and (max-width: 1930px) {
    font-size: 4.8rem;
    line-height: 5rem;
    padding: 0px 40px;
  }
  @media only screen and (max-width: 1430px) {
    font-size: 3.3rem;
    line-height: 3.4rem;
    padding: 0px 23px;
  }
  @media only screen and (max-width: 600px) {
    font-size: 2.8rem;
    line-height: 3.1rem;
    padding: 0px 3px;
  }
}
h4 {
  font-size: 3.1rem;
  line-height: 3.5rem;
  padding: 0px 0px;
  @media only screen and (max-width: 1930px) {
    font-size: 3.1rem;
    line-height: 3.5rem;
    padding: 0px 0px;
  }
  @media only screen and (max-width: 1430px) {
    font-size: 3.1rem;
    line-height: 3.5rem;
    padding: 0px 0px;
  }
  @media only screen and (max-width: 600px) {
    font-size: 1.7rem;
    line-height: 2rem;
    padding: 0px 0px;
  }
  a {
    padding-bottom: 7px !important;
    display: inline-block;
    line-height: 2.5rem;
  }
}
h5 {
  font-size: 2rem;
  line-height: 2.2rem;
  @media only screen and (max-width: 600px) {
    font-size: 1.8rem;
    line-height: 2rem;
    margin-top: 0px;
    margin-bottom: 20px;
  }
  @media only screen and (max-width: 321px) {
    font-size: 1.4rem;
    line-height: 1.8rem;
    margin-top: 0px;
    margin-bottom: 24px;
  }
}
h6 {
  font-size: 1.5rem;
  line-height: 1.7rem;
  @media only screen and (max-width: 1430px) {
  }
  @media only screen and (max-width: 600px) {
    font-size: 1.05rem;
    line-height: 1.3rem;
  }
}
a {
  color: #000075;
  text-decoration: none;
  transition: all 0.3s ease;
  padding-bottom: 3px;
  &:hover {
    background-color: #ffff76;
    color: #000075;
  }
}
p {
  font-weight: bold;
  @media only screen and (max-width: 1980px) {
    font-size: 0.9rem;
    line-height: 1.1rem;
  }
  @media only screen and (max-width: 1480px) {
    font-size: 0.82rem;
    line-height: 1.1rem;
  }
  &.smaller {
    padding: 2px;
    margin: 2px;
    font-size: 0.73rem !important;
    font-weight: bold !important;
    a {
      color: #2effc3;
      &:hover {
        color: #ffff76;
        background-color: transparent;
      }
    }
    &.error {
      color: #2effc3;
      margin: 4px;
    }
  }
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.full-page-section {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
}
.not-full {
  min-height: 70vh;
}
.trigger {
  min-height: 100vh;
  width: 100%;
  background-color: pink;
}
.content {
  padding: 20px;
  width: 100%;
  max-width: 820px;
  @media only screen and (max-width: 1930px) {
    max-width: 640px;
  }
  @media only screen and (max-width: 1430px) {
    max-width: 550px;
  }
}
span.blue {
  color: #000075;
}
.button {
  background-color: #000075;
  padding: 10px 40px;
  border-radius: 30px;
  display: inline-block;
  font-size: 0.9rem;
  color: #ffff76;
  margin-top: 10px;
  cursor: pointer;
  @media only screen and (max-width: 600px) {
    margin-top: 2px;
  }
}
.animate {
  transition-delay: 0.2s;
  transition-duration: 0.3s;
  transition-timing-function: ease-in;
}
.slide-up {
  transform: translateY(200px);
  opacity: 0;
}
.slide-up.animate-active {
  transform: translateY(0px);
  opacity: 1;
}
.sticky {
  position: absolute;
  width: 100%;
}
.stick-me {
  padding-top: 100vh;
  .sticky {
    top: 0px;
    left: 0px;
    position: fixed;
    &.no-stick {
      position: relative;
    }
  }
}
.stick-me-done {
  padding-bottom: 100vh;
}
// scenes
.scene {
  position: relative;
}
.pop {
  position: absolute;
  left: 0px;
  top: 0px;
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
  width: 100%;
  z-index: 99;
  background-color: rgba(57, 57, 67, 0.95);
  border: 15px solid #ff5555;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  transition: all 1s ease;
  &.pop-terms {
    background-color: rgba(57, 57, 67, 0);
    left: 0px;
    top: 0px;
    height: 100vh;
    width: calc(100vw - 15px);
    border: 0px;
    .pop-float {
      border: 15px solid #ff5555;
      background-color: rgba(57, 57, 67, 1);
      margin: 0px !important;
    }
  }
  .content {
    color: #fff;
    text-align: left;
    transition: all 0.5s ease;
    &:first-child {
      padding-top: 10vh;
    }
    &:last-child {
      padding-bottom: 10vh;
    }
    &.center {
      text-align: center;
    }
    p {
      font-weight: normal;
      font-size: 1.2em;
    }
    position: relative;
    &.summary {
      transition: all 0.5s ease;
      max-height: 80vh;
      overflow: hidden;
    }
    .button {
      background-color: #2effc3;
      color: #000075;
      &:hover {
      }
    }
    // &.summary:after {
    //   content: ' ';
    //   transition: all 0.5s ease;
    //   height: 20vh;
    //   position: absolute;
    //   left: 0px;
    //   bottom: -1px;
    //   width: 100%;
    //   background: linear-gradient(to bottom, rgba(57, 57, 67, 0) 0%, rgba(57, 57, 67, 1) 100%);
    //   z-index: 999;
    // }
  }
  &.show-all {
    height: auto;
    .content {
      &.summary {
        max-height: 9999px;
        &.summary:after {
          display: none;
        }
      }
    }
  }
}
.one-page-down {
  position: absolute;
  top: 102vh;
}
.scale-trans {
  transform: scale(1.2);
  transition: all 1.6s ease 1s;
  &.animate-active {
    transform: scale(1);
  }
}
.fix-me {
}
</style>
